import PropTypes from "prop-types";
import noop from "no-op";
//import { addonTypes } from './addonTypes';
import customTypes from "../customTypes";

export const addonsDefaultProps = {
  addons: [],
  selectedAddonsGroup: {},
  onAddonIncrementClick: noop
};

export const addonsTypes = {
  id: customTypes.stringOrNumber.isRequired,
  addons: PropTypes.array,
  selectedAddonsGroup: PropTypes.object,
  onAddonIncrementClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/types/addonsTypes/addonsTypes.js